import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

let initialized = false;

export const fetchTranslations = async () => {
  if (initialized) return i18n;

  try {
    const response = await fetch('https://azumayavietnam.com/api/content/ac90d328-c5d5-473a-8902-3c00d2b2f58a/website');
    const responseData = await response.json();

    const resources = {
      en: { translation: responseData.en || {} },
      ja: { translation: responseData.ja || {} },
      ko: { translation: responseData.ko || {} },
      vi: { translation: responseData.vi || {} },
    };

    await i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources,
        fallbackLng: 'en',
        debug: false,
        detection: {
          order: ['cookie', 'navigator'],
          caches: ['cookie'],
          cookieOptions: { path: '/', sameSite: 'strict' },
        },
        supportedLngs: ['en', 'ja', 'ko', 'vi'],
        interpolation: { escapeValue: false },
        react: { useSuspense: false },
      });

    initialized = true;
  } catch (error) {
    console.error('Error fetching translations:', error);
  }

  return i18n;
};

fetchTranslations();

export default i18n;

